import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input } from "reactstrap";
import { set_params_list } from "../../slices/workflow_builder/reducer";

const Global_Storage = ({ nodes, edges }) => {
  const [inputValue, setInputValue] = useState("");
  const [list, setList] = useState([]);
  const { params_list, workflow_list } = useSelector(
    (state) => state.WorkFlowBuilder
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (workflow_list?.workflow_data?.workflow_data?.params) {
      setList(workflow_list?.workflow_data?.workflow_data?.params);
      dispatch(
        set_params_list(workflow_list?.workflow_data?.workflow_data?.params)
      );
    }
  }, [workflow_list]);

  useEffect(() => {
    if (workflow_list?.workflow_data?.workflow_data?.params) {
      setList(workflow_list?.workflow_data?.workflow_data?.params);
    }
  }, [workflow_list]);

  //handling input value to add in list
  const handleAdd = () => {
    const trimmedValue = inputValue.trim();

    if (trimmedValue !== "" && !list.includes(trimmedValue)) {
      const updatedList = [...list, trimmedValue];
      setList(updatedList);
      dispatch(set_params_list(updatedList));
      setInputValue("");
    }
  };
  //handling vallue to remove from list
  const handleRemove = (index) => {
    const json_string_nodes = JSON.stringify(nodes);
    const json_string_edges = JSON.stringify(edges);
    const key = params_list[index];
    const isUsed =
      json_string_nodes.includes(`"taken_input_from":"${key}"`) ||
      json_string_edges.includes(`"taken_input_from":"${key}"`) ||
      json_string_nodes.includes(`"send_output_to":"${key}"`) ||
      json_string_edges.includes(`"send_output_to":"${key}"`);

    if (isUsed) {
      alert(
        "This variable is being used in your Workflow. Kindly remove it from there before deleting it here."
      );
      return
    }

    const updatedList = [...list];
    updatedList.splice(index, 1);
    dispatch(set_params_list(updatedList));
    setList(updatedList);
  };
  return (
    <>
      <div className="global_storage_wrap">
        <div className="sidebar_heading mb-3">
          <h3>
            <i className="ri-side-bar-line"></i> Global Storage
          </h3>
        </div>
        <div className="list_add">
          <div className="add_variable">
            <Input
              className="form-control"
              placeholder="Storage Name"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleAdd()}
            />
            <Button className="add_to_list" onClick={handleAdd}>
              <i className="ri-add-fill"></i>
            </Button>
          </div>
          <div className="display_list">
            <ul>
              {list.map((item, index) => (
                <li key={index}>
                  <span>{item}</span>
                  <span
                    onClick={() => handleRemove(index)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="ri-close-fill"></i>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Global_Storage;
